<template>
  <div color="#1B5E20">
    <v-card max-width="1000" class="mx-auto hidden-sm-and-down" elevation="0">
      <br />
      <br />
      <v-row>
        <v-col cols="3" sm="3" md="3">
          <v-card class="mx-auto black--text" max-width="300">
            <v-list dense>
              <span class="mdi mdi-segment">CATEGORY</span>
              <v-list-item-group v-model="selectedItem" color="success">
                <v-list-item
                  v-for="(item, i) in categories"
                  :key="i"
                  :to="'/category/' + item.slug"
                >
                  <v-icon>{{ item.icon }}</v-icon>
                  <v-list-item-content>
                    <v-list-item-title
                      v-text="item.name"
                      color="transparent"
                    ></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="9" sm="9" md="9">
          <v-card class="mx-auto" max-width="100%" max-height="100%">
            <v-carousel cycle height="400" hide-delimiter-background show-arrows-on-hover>
              <v-carousel-item
                v-for="(item, i) in image_banner"
                :key="i"
                :src="getImage('/' + item)"
                reverse-transition="fade-transition"
                transition="fade-transition"
              >
              </v-carousel-item>
            </v-carousel>
          </v-card>
          <v-card
            class="mx-auto"
            max-width="100%"
            max-height="100%"
            elevation="0"
            style="display: none"
          >
            <v-alert :type="type_information" variant="tonal">
              <marquee>{{ information }}</marquee>
            </v-alert>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <v-skeleton-loader
      v-if="sliderLoad"
      type="card"
      class="hidden-sm-and-up"
    ></v-skeleton-loader>
    <v-card
      max-width="100%"
      max-height="100%"
      class="mx-auto hidden-sm-and-up"
      v-show="!sliderLoad"
    >
      <br />
      <br />
      <br />
      <v-carousel cycle height="200" hide-delimiter-background show-arrows-on-hover>
        <v-carousel-item
          v-for="(item, i) in image_banner"
          :key="i"
          :src="getImage('/' + item)"
          reverse-transition="fade-transition"
          transition="fade-transition"
        >
        </v-carousel-item>
      </v-carousel>
    </v-card>

    <!-- vidio indorobotika -->
    <v-card
      max-width="1000"
      class="mx-auto"
      elevation="0"
      style="background-color: transparent; display: none"
    >
      <v-container grid-list-lg>
        <v-row class="mx-auto">
          <v-col cols="6">
            <div class="text-left">
              <v-btn small text class="black--text"> Recommendation Vidio </v-btn>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="text-right">
              <v-btn small text to="/promotions" class="black--text">
                all<v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-auto">
          <v-col>
            <v-slide-group
              v-model="model"
              active-class="success"
              style="background-color: transparent"
            >
              <v-slide-item
                v-for="category in categories"
                :key="category"
                v-slot="{ active, toggle }"
              >
                <v-card :to="'/category/' + category.slug" class="ma-2" circle>
                  <iframe
                    height="200px"
                    width="300px"
                    :src="result"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <!-- <br /> -->
    <v-card
      max-width="1000"
      class="mx-auto hidden-sm-and-down"
      :style="products_promotions.length != 0 ? '' : 'display:none;'"
    >
      <v-row class="mx-auto">
        <v-col cols="3">
          <div class="text-left">
            <v-btn small text class="black--text"> Promotion </v-btn>
          </div>
        </v-col>
        <v-col cols="6">
          <div class="text-center">
            <h3>{{ timerOutput }}</h3>
          </div>
        </v-col>
        <v-col cols="3">
          <div class="text-right">
            <v-btn small text to="/promotions" class="black--text">
              all<v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>

      <!-- show-arrows -->
      <v-parallax :src="getImage('/' + image_promotion_web)" height="10px">
        <v-slide-group v-model="model" active-class="success" style="margin-top: 100px">
          <!-- <v-img src="img/categories_template.png" height="220px" width="100px"></v-img> -->

          <v-slide-item
            v-for="product in products_promotions"
            :key="product"
            v-slot="{ active, toggle }"
          >
            <v-card
              :to="'/product/' + product.slug"
              class="ma-2"
              height="250px"
              width="150px"
              circle
            >
              <v-img
                :src="getImage('/' + product.cover)"
                class="red--text"
                height="150px"
                width="150px"
              >
              </v-img>

              <v-card-text
                style="height: 10%; overflow: hidden"
                small
                text
                class="black--text"
                v-text="product.title"
              >
              </v-card-text>
              <v-card-text class="text-sm">
                <span class="text-decoration-line-through">
                  Rp
                  {{ parseInt(product.priceTmp).toLocaleString("id-ID") }}
                </span>
                <br />
                <span class="red--text">
                  Rp {{ parseInt(product.price).toLocaleString("id-ID") }}
                </span>
              </v-card-text>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </v-parallax>
    </v-card>
    <!-- =========================================================== -->
    <v-skeleton-loader
      v-if="promotionLoad"
      type="card"
      class="hidden-sm-and-up"
    ></v-skeleton-loader>
    <v-card
      v-show="!promotionLoad"
      max-width="1000"
      class="mx-auto hidden-sm-and-up"
      :style="products_promotions.length != 0 ? '' : 'display:none;'"
    >
      <v-row class="mx-auto">
        <v-col cols="3">
          <div class="text-left">
            <v-btn small text class="black--text"> Promotion </v-btn>
          </div>
        </v-col>
        <v-col cols="6">
          <div class="text-center">
            <h4>{{ timerOutputApp }}</h4>
          </div>
        </v-col>

        <v-col cols="3">
          <div class="text-right">
            <v-btn small text to="/promotions" class="black--text">
              all<v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>

      <!-- show-arrows -->
      <v-parallax :src="getImage('/' + image_promotion_app)" height="10px">
        <v-slide-group v-model="model" active-class="success" style="margin-top: 50px">
          <v-slide-item
            v-for="product in products_promotions"
            :key="product"
            v-slot="{ active, toggle }"
          >
            <v-card
              :to="'/product/' + product.slug"
              class="ma-2"
              circle
              height="250px"
              width="150px"
            >
              <v-img
                :src="getImage('/' + product.cover)"
                class="red--text"
                height="150px"
                width="150px"
              >
              </v-img>

              <v-card-text
                style="height: 10%; overflow: hidden"
                small
                text
                class="black--text"
                v-text="product.title"
              >
              </v-card-text>
              <v-card-text class="text-sm">
                <span class="text-decoration-line-through">
                  Rp
                  {{ parseInt(product.priceTmp).toLocaleString("id-ID") }}
                </span>
                <br />
                <span class="red--text">
                  Rp {{ parseInt(product.price).toLocaleString("id-ID") }}
                </span>
              </v-card-text>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </v-parallax>
    </v-card>
    <br />
    <v-skeleton-loader
      v-if="categoryLoad"
      type="card"
      class="hidden-sm-and-up"
    ></v-skeleton-loader>
    <v-card
      max-width="1000"
      class="mx-auto hidden-sm-and-up"
      v-show="!categoryLoad"
      elevation="0"
    >
      <v-row class="mx-auto">
        <v-col cols="6">
          <div class="text-left">
            <v-btn small text class="black--text"> Category </v-btn>
          </div>
        </v-col>
        <v-col cols="6">
          <div class="text-right">
            <v-btn small text to="/categories" class="black--text">
              all<v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>

      <!-- show-arrows -->
      <v-slide-group
        v-model="model"
        active-class="success"
        style="background-color: transparent"
      >
        <!-- <v-img :src="getImage('/' + image_category)" height="120px" width="100px"></v-img> -->
        <v-slide-item
          v-for="category in categories"
          :key="category"
          v-slot="{ active, toggle }"
        >
          <v-card :to="'/category/' + category.slug" class="ma-2" circle>
            <v-img
              :src="getImage('/' + category.image)"
              class="red--text"
              height="100px"
              width="100px"
            >
            </v-img>
            <!-- <v-card-text
              style="height: 100%; overflow: hidden"
              small
              text
              class="black--text"
              v-text="category.name"
            ></v-card-text> -->
          </v-card>
        </v-slide-item>
      </v-slide-group>
    </v-card>
    <br />
    <v-skeleton-loader
      v-if="productLoad"
      type="card"
      class="hidden-sm-and-up"
    ></v-skeleton-loader>

    <v-card max-width="1000" class="mx-auto" elevation="0" v-show="!productLoad">
      <v-container grid-list-lg>
        <v-row class="mx-auto">
          <v-col cols="6">
            <div class="text-left">
              <v-btn small text class="black--text"> recommendation products </v-btn>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="text-right">
              <v-btn small text to="/products" class="black--text">
                all<v-icon>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-layout wrap style="background-color: transparent">
          <v-flex
            v-for="product in products"
            :key="`product-` + product.id"
            class="hidden-sm-and-down"
            xs2
          >
            <product-item :product="product" height="200px" width="200px" />
          </v-flex>
          <v-flex
            v-for="product in products"
            :key="`product-` + product.id"
            class="hidden-sm-and-up"
            xs6
          >
            <product-item :product="product" height="200px" width="200px" />
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-text class="text-center">
        <v-btn rounded color="white" outlined elevation="5" large @click="getProduct(6)">
          <v-list-item-title class="black--text">Muat Lebih Banyak</v-list-item-title>
        </v-btn>
      </v-card-text>
    </v-card>
    <br />

    <v-layout row justify-center>
      <v-dialog v-model="dialogProsesed" persistent max-width="290" id="dialogProsesed">
        <v-progress-linear indeterminate color="blue" height="30"
          ><span>Waits...</span></v-progress-linear
        >
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
export default {
  components: {
    ProductItem: () =>
      import(/* webpackChunkName: "product-item" */ "@/components/ProductItem.vue"),
  },

  data: () => ({
    categories: [],
    products: [],
    //sourch image slider
    list_images: [],
    sum: 0,
    type_information: "",
    information: "",
    products_promotions: [],
    image_promotion_web: "",
    image_promotion_app: "",
    image_category: "",
    image_banner: [],
    countDownToTime: null,
    timerOutput: null,
    timerOutputApp: null,
    countDownToTimeTmp: new Date(),
    dialogProsesed: false,
    sliderLoad: true,
    promotionLoad: true,
    productLoad: true,
    categoryLoad: true,
    youtubeURL: "",
    result: "",
  }),
  methods: {
    getProduct(count) {
      this.dialogProsesed = true;
      if (this.sum == 0) {
        this.sum = 24 + count;
      } else {
        this.sum = this.sum + count;
      }
      this.axios
        .get("/ecommerce-products/top/" + this.sum)
        .then((response) => {
          let { data } = response.data;
          this.products = data;
          this.dialogProsesed = false;
        })
        .catch((error) => {
          this.dialogProsesed = false;
          let { responses } = error;
          console.log(responses);
        });
    },
    go() {
      let url = "/products-eccomerce";
      this.axios
        .get(url)
        .then((response) => {
          let { data } = response.data;
          this.products_promotions = data;
          Array.from(this.products_promotions).forEach(
            (element) => (element.priceTmp = element.price)
          );
          Array.from(this.products_promotions).forEach(
            (element) =>
              (element.price = parseInt(
                element.price - element.price * (element.result / 100)
              ))
          );
          this.promotionLoad = false;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    startTimer: function () {
      this.countDownToTimeTmp = new Date(this.countDownToTime).getTime();
      const timeNow = new Date().getTime();
      const timeDifference = this.countDownToTimeTmp - timeNow;
      const millisecondsInOneSecond = 1000;
      const millisecondsInOneMinute = millisecondsInOneSecond * 60;
      const millisecondsInOneHour = millisecondsInOneMinute * 60;
      const millisecondsInOneDay = millisecondsInOneHour * 24;
      const differenceInDays = timeDifference / millisecondsInOneDay;
      const remainderDifferenceInHours =
        (timeDifference % millisecondsInOneDay) / millisecondsInOneHour;
      const remainderDifferenceInMinutes =
        (timeDifference % millisecondsInOneHour) / millisecondsInOneMinute;
      const remainderDifferenceInSeconds =
        (timeDifference % millisecondsInOneMinute) / millisecondsInOneSecond;
      const remainingDays = Math.floor(differenceInDays);
      const remainingHours = Math.floor(remainderDifferenceInHours);
      const remainingMinutes = Math.floor(remainderDifferenceInMinutes);
      const remainingSeconds = Math.floor(remainderDifferenceInSeconds);
      this.timerOutput =
        remainingDays +
        " Days " +
        ": " +
        remainingHours +
        " Hours " +
        ": " +
        remainingMinutes +
        " Minutes " +
        ": " +
        remainingSeconds +
        " Seconds";
      this.timerOutputApp =
        remainingDays +
        ": " +
        remainingHours +
        ": " +
        remainingMinutes +
        ": " +
        remainingSeconds;
    },

    loadURL() {
      const youtubeEmbedTemplate =
        "https://www.youtube.com/embed/dYVfxph5Z4E?si=R20GrpxU0y9RGQvO";
      const url = this.youtubeURL.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      console.log("url", url);
      const YId = undefined !== url[2] ? url[2].split(/[^0-9a-z_/\\-]/i)[0] : url[0];
      console.log("YId", YId);
      if (YId === url[0]) {
        console.log("not a youtube link");
      } else {
        console.log("it's  a youtube video");
      }
      const topOfQueue = youtubeEmbedTemplate.concat(YId);
      console.log("topOfQueue", topOfQueue);
      this.result = topOfQueue;
      this.youtubeURL = "";
    },
  },
  mounted() {
    setInterval(() => {
      this.startTimer();
    }, 1000);
  },
  created() {
    this.axios
      .get("/ecommerce-categories/random/10")
      .then((response) => {
        let { data } = response.data;
        this.categories = data;
        this.categoryLoad = false;
      })
      .catch((error) => {
        let { responses } = error;
        console.log(responses);
      });

    this.axios
      .get("/ecommerce-products/top/24")
      .then((response) => {
        let { data } = response.data;
        this.products = data;
        this.productLoad = false;
      })
      .catch((error) => {
        let { responses } = error;
        console.log(responses);
      });

    this.axios
      .get("/commonImage/slider")
      .then((response) => {
        let { data } = response.data;
        this.list_images = data;
        Array.from(this.list_images).forEach((element) => {
          if (element.image_function == "Promotion") {
            if (element.version == "web") {
              this.image_promotion_web = element.image_url;
            }
            if (element.version == "app") {
              this.image_promotion_app = element.image_url;
            }
          }
          if (element.image_function == "Category") {
            this.image_category = element.image_url;
          }
          if (element.image_function == "Banner") {
            this.image_banner.push(element.image_url);
          }
        });
        this.sliderLoad = false;
      })
      .catch((error) => {
        let { responses } = error;
        console.log(responses);
      });

    this.axios
      .get("/information")
      .then((response) => {
        this.type_information = response.data.data_type;
        this.information = response.data.data_infromation;
      })
      .catch((error) => {
        let { responses } = error;
        console.log(responses);
      });

    this.axios
      .get("/ecommerce-promotion-countDown")
      .then((response) => {
        let { data } = response.data;
        this.countDownToTime = data;
      })
      .catch((error) => {
        let { responses } = error;
        console.log(responses);
        this.countDownToTime = null;
      });
    this.go();
    this.loadURL();
    // navigator.geolocation.getCurrentPosition(
    //       position => {

    //         const lati = position.coords.latitude
    //         const long = position.coords.longitude
    //         console.log(lati,'||' ,long);

    //          let formData = {
    //               'latitude' : lati,
    //               'longitude' : long
    //           }
    //         console.log(formData);
    //         this.axios.post('/location/'+formData)

    //       },
    //       error => {
    //         console.log(error.message);
    //       },
    //   )
  },
};
</script>
